import {detailServicesPath} from "../../../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/modifying-details-order/'

export default class ModifyingDetailsOrderService {

    static async excluded(id, status) {
        return axios.patch(restUrl + id + '/excluded?status=' + status, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
